<script>
	import PageHeader from "./PageHeader.svelte";
	import CardImovel from './CardImovel.svelte';

	export let filters = {};
	export let afterLoadRealties = null;
	export let showPaginator = true;
	export let showNextPrev = false;
	export let holderClass = 'row';
	export let colClass = 'col';
	export let cardType = 'card';
	export let notFoundClass = '';
	export let pageSize = 15;

	let currentPage = 0;
	let numberOfPages = 0;
	let loading = false;

	let pages = [];
	
	function pageChange(newPage) {
		loading = true;
		filters = {...filters, currentPage:newPage};

		scrollTo('.lista-imoveis');
	}

	async function getRealties(filters) {
		loading = true;

		if (filters.recursos != null && typeof(filters.recursos) === 'string' && filters.recursos.length > 0) {
			filters.recursos = filters.recursos.split(',');
		}

		if (filters.recursos != null && filters.recursos.length > 0) {
			filters.vistasoftrest_custom = filters.recursos.join(',Sim&') + ',Sim';
			delete filters.recursos;
		}

		let url = `${atria.mainURL}/Services/RealEstate/JSONP/List.aspx?mode=realties&callback=null&`;
		url += Object.entries({...filters, pageSize: pageSize}).map(e=>`${e[0]}=${e[1]}`).join('&');
		let response = await fetch(url,{
			method: 'GET',
			mode: 'cors'
		});

		let data = await response.json();
		return data;
	}

	$: imoveis = getRealties(filters).then(json => {
		pages = new Array(json.NumberOfPages).fill(null).map((v, i)=> (i + 1));

		currentPage = json.CurrentPage;
		numberOfPages = json.NumberOfPages;

		if (afterLoadRealties != null) {
			afterLoadRealties(json);
		}

		loading = false;
		return json;
	});

	function prevPage() {
		if (currentPage > 1) {
			pageChange(currentPage - 1);
		}
	}
	function nextPage() {
		if (currentPage < numberOfPages) {
			pageChange(currentPage + 1);
		}
	}
</script>

<div class="imoveis">
	{#await imoveis}
		<!-- Tela de carregamento dos Imóveis -->
		<div class={holderClass}>
			<div class={colClass}>
				<CardImovel loading={true} />
			</div>
			<div class={colClass}>
				<CardImovel loading={true} />
			</div>
			<div class={colClass}>
				<CardImovel loading={true} />
			</div>
		</div>
	{:then data}
		<!-- Imóveis -->
		<div class={holderClass}>
			{#each data.Items as imovel, i}
				<div class={colClass}>
					<CardImovel type={cardType} realty={imovel} index={i} />
				</div>
			{:else}
				<div class={colClass + ' ' + notFoundClass}>
					<p>Nenhum imóvel encontrado.</p>
				</div>
			{/each}
		</div>
		<!-- Paginação -->
		{#if data.NumberOfPages > 1 && showPaginator}
			<nav aria-label="pagination">
				<ul class="pagination justify-content-center mt-30">
					{#each pages as page, i}
						{#if page === data.CurrentPage}
							<li class="page-item active">
								<a class="page-link" aria-label="Página atual: {page}}">{page}</a>
							</li>
						{:else}
							<li>
								<a class="page-link" aria-label="Vai para página: {page}" on:click={()=>{pageChange(page)}}>{page}</a>
							</li>
						{/if}               
					{/each}
				</ul>
			</nav>
		{/if}
		{#if showNextPrev}
		<div class="flex flex-center gap-10 pt-20">
			{#if currentPage > 1}
			<button class="btn btn-seconday" on:click={prevPage}><i class="fas fa-chevron-left"></i> Página anterior</button>
			{/if}
			{#if currentPage < numberOfPages}
			<button class="btn btn-primary" on:click={nextPage}>Próxima página <i class="fas fa-chevron-right"></i></button>
			{/if}
		</div>
		{/if}
	{/await}
</div>

<style type="text/sass">
@import 'public/assets/sass/variables.sass'

// Paginação 
.pagination
	flex-wrap: wrap
	
.page-item.active .page-link
	background-color: $color-secondary
	border-color: $color-secondary
.page-link
	color: $color-secondary

</style>